import React from "react";
import "./AboutMe.css";
import aboutImg1 from "../../../assets/images/about/aboutMe1.jpg";
const AboutMe = () => {
  return (
    <section id="aboutMe" className="bg-main2 text-white">
      <div id="sectionTitle" className="sectionTitle pt-32 pb-5 text-center">
        <h2 className="text-5xl font-bold">About Me</h2>
      </div>
      <div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row ">
        <div className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128">
          <img
            src={aboutImg1}
            alt="About Me"
            className="object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 rounded-md"
          />
        </div>
        <div className="flex flex-col p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
          <h3 className="text-2xl font-bold ">
            I'm
            <span className="text-secondary"> Mostafizur Rahman</span>
          </h3>
          <h6 className="mt-2 mb-8 text-sm font-light text-stone2 uppercase tracking-widest">
            Mern Stack and WordPress Developer
          </h6>
          <p className="mb-7 text-justify text-base font-normal text-stone2 leading-5">
            I've always had a natural curiosity for the{" "}
            <span className="font-bold">Web and Programming. I</span>
            am seeking knowledge for the last few years about Web development
            and programming and I love it. You will find me hardworking, honest,
            a quick learner, and very ambitious. I am always busy to keep
            learning new technologies.
          </p>
          <p className="mb-7 text-justify text-base font-normal text-stone2 leading-5">
            I'm open to <span className="font-bold">Job</span> opportunities
            where I can contribute, learn and grow. If you have a good
            opportunity that matches my skills and experience then don't
            hesitate to <span className="font-bold">contact me.</span>
          </p>
          <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
            <a
              href="Mostafizur Rahman MERN Stack developer.pdf"
              download="Mostafizur Rahman MERN Stack developer.pdf"
              className="px-8 py-3 text-lg font-semibold rounded bg-secondary text-white"
            >
              Download Resume
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
